import { Button, Stack, Typography } from '@locus-taxy/disco-ui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { getTestId } from '@locus-taxy/encore-utils';
import { TestIdAction } from '../../utils/testIdUtils';

interface SessionAccessSectionProps {
  onLogout: () => void;
}

export function SessionAccessSection({
  onLogout,
}: Readonly<SessionAccessSectionProps>) {
  const { t } = useTranslation();

  return (
    <div
      className="rounded-md border border-border bg-card"
      data-testid={getTestId({
        action: TestIdAction.VIEW,
        object: 'session-access-section',
        page: 'account',
      })}
    >
      <Stack direction="row" align="center" gap={2} className="px-8 py-6">
        <Typography variant="h6" fontWeight="semibold" className="flex-1">
          {t('dashboard.userDetails.sessionAccess', 'Session & Access')}
        </Typography>

        <Button
          variant="outline"
          size="lg"
          onClick={onLogout}
          className="text-destructive border-destructive hover:bg-destructive/10"
          data-testid={getTestId({
            action: TestIdAction.LOGOUT,
            object: 'button',
            page: 'account',
          })}
        >
          {t('dashboard.userDetails.logout', 'Logout')}
        </Button>
      </Stack>
    </div>
  );
}
